// extracted by mini-css-extract-plugin
export var buttons_container = "buttons-module--buttons_container--LVwEU";
export var content = "buttons-module--content--lEhwX";
export var text = "buttons-module--text--seBYy";